"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toArabicWord = exports.arabicWord = exports.ArabicWord = exports.NumberSection = exports.ArabicWordConfig = void 0;

var ArabicWordConfig =
/** @class */
function () {
  function ArabicWordConfig() {
    this.config = {
      delimiter: 'فاصل',
      numberSectionsDelimiter: 'و',

      get tensPrefix() {
        return 'ون';
      } // readonly


    };
    this.feminizeSign = 'ة';
    this.numbers = {
      '0': 'صفر',
      '1': 'واحد',
      '2': 'أثنان',
      '3': 'ثلاث',
      '4': 'أربع',
      '5': 'خمس',
      '6': 'ست',
      '7': 'سبع',
      '8': 'ثمان',
      '9': 'تسع',
      '10': 'عشر',
      '11': 'إحدى عشر',
      '12': 'إثنا عشر',
      '20': 'عشرون',
      '100': 'مائة',
      '200': 'مائتان',
      '1e3': 'ألف',
      '2e3': 'ألفين',
      '3e3-1e4': 'آلاف',
      '1e4+': 'ألف',
      '1e6': 'مليون',
      '2e6': 'مليونان',
      '3e6-1e7': 'ملاين',
      '1e7+': 'مليون',
      '1e9': 'مليار',
      '2e9': 'ملياران',
      '3e9-1e10': 'مليارات',
      '1e10+': 'مليار',
      '1e12': 'بليون',
      '2e12': 'بليونان',
      '3e12-1e13': 'بلايين',
      '1e13+': 'بليون',
      '1e15': 'تريليون',
      '2e15': 'تريليونان',
      '2e15-1e16': 'تريليونات',
      '1e16+': 'تريليون',
      '1e18': 'كوادرليون',
      '2e18': 'كوادرليونان',
      '2e18-1e19': 'كوادرليونات',
      '1e19+': 'كوادرليون'
    };
  }

  ArabicWordConfig.prototype.overrideConfig = function (config) {
    delete config.tensPrefix;

    if (config.delimiter) {
      config.delimiter = config.delimiter.replace(' ', '');
    }

    if (config.numberSectionsDelimiter) {
      config.numberSectionsDelimiter = config.numberSectionsDelimiter.replace(' ', '');
    }

    this.config = Object.assign(this.config, config);
  };

  ArabicWordConfig.prototype.getAll = function () {
    return this.config;
  };

  return ArabicWordConfig;
}();

exports.ArabicWordConfig = ArabicWordConfig;

var NumberSection =
/** @class */
function () {
  function NumberSection(arabicWordConfig) {
    this.arabicWordConfig = arabicWordConfig;
  }

  NumberSection.prototype.process = function (num) {
    return this.processSection(num).reverse();
  };

  NumberSection.prototype.processSection = function (section) {
    if (Number(section) === 0) {
      return this.processZero();
    } else {
      return this.processGreaterThanZero(section);
    }
  };

  NumberSection.prototype.processZero = function () {
    return this.getWordForZero();
  };

  NumberSection.prototype.processGreaterThanZero = function (section) {
    var _this = this; // the section greater than zero


    var parts = this.splitIntoParts(section);
    var partsAsWords = [];
    parts.forEach(function (p, i) {
      var wordForPart = _this.getWordByNumberSectionIndex(p, i);

      if (!!wordForPart) {
        partsAsWords.push(wordForPart);
      }
    });
    return partsAsWords;
  };

  NumberSection.prototype.getWordForZero = function () {
    return [this.arabicWordConfig.numbers[0]];
  };
  /**
   * convert the number to parts every part has 3 numbers for example
   * 10 to be 010 and 12345 to be 012345
   * @param word the number in string
   * @returns
   */


  NumberSection.prototype.splitIntoParts = function (word) {
    var parts = [];

    for (var i = word.length - 1; i >= 0; i -= 3) {
      var part = (word[i - 2] != null ? word[i - 2] : '0') + (word[i - 1] != null ? word[i - 1] : '0') + (word[i] != null ? word[i] : '0');
      parts.push(part);
    }

    return parts;
  };

  NumberSection.prototype.getWordByNumberSectionIndex = function (part, numberSectionIndex) {
    var partAsNumber = Number(part);
    var word = null;

    if (numberSectionIndex == 0) {
      word = this.getWordForPart(part);
    } else if (partAsNumber == 1) {
      word = this.arabicWordConfig.numbers["1e".concat(numberSectionIndex * 3)];
    } else if (partAsNumber == 2) {
      word = this.arabicWordConfig.numbers["2e".concat(numberSectionIndex * 3)];
    } else {
      var partWord = this.getWordForPart(part) + ' ';

      if (partAsNumber >= 3 && partAsNumber <= 10) {
        word = partWord += this.arabicWordConfig.numbers["3e".concat(numberSectionIndex * 3, "-1e").concat(numberSectionIndex * 3 + 1)];
      } else if (partAsNumber >= 11) {
        word = partWord += this.arabicWordConfig.numbers["1e".concat(numberSectionIndex * 3 + 1, "+")];
      }
    }

    return word;
  };

  NumberSection.prototype.getWordForPart = function (part) {
    var n_0 = part[0];
    var n_1 = part[1];
    var n_2 = part[2];
    var n_0Word = this.getWordForHundreds(n_0);
    var nGroup_0 = n_1 + n_2;
    var nGroupNum = Number(nGroup_0);
    var n_1Word = this.getWordForTens(nGroup_0);

    if (nGroupNum == 0) {
      return n_0Word;
    }

    if (n_0Word) {
      return n_0Word + (' ' + this.arabicWordConfig.getAll().numberSectionsDelimiter + ' ') + n_1Word;
    }

    return n_1Word;
  };

  NumberSection.prototype.getWordForHundreds = function (char) {
    var charNum = Number(char);
    var word = null;

    if (charNum == 1) {
      word = this.arabicWordConfig.numbers[100];
    } else if (charNum == 2) {
      word = this.arabicWordConfig.numbers[200];
    } else if (charNum >= 3 && charNum <= 9) {
      word = this.getWordFromThreeHundredToNineHundred(char);
    }

    return word;
  };

  NumberSection.prototype.getWordFromThreeHundredToNineHundred = function (char) {
    return this.arabicWordConfig.numbers[char] + this.arabicWordConfig.numbers[100];
  };

  NumberSection.prototype.getWordForTens = function (tensGroup) {
    var tensNum = Number(tensGroup);

    if (tensNum == 0) {
      return this.arabicWordConfig.numbers[0];
    } else if (tensNum >= 1 && tensNum <= 12) {
      if (tensNum == 10) {
        return this.getWordForTen(tensNum);
      }

      return this.arabicWordConfig.numbers[tensNum];
    } else if (tensNum >= 13 && tensNum <= 19) {
      return this.getWordFromThirteenToNineTeen(tensGroup);
    } else if (tensNum >= 20 && tensNum <= 99) {
      return this.getWordFromTwentyToNinetyNine(tensGroup);
    }

    return null;
  };

  NumberSection.prototype.getWordForTen = function (num) {
    return "".concat(this.arabicWordConfig.numbers[num]).concat(this.arabicWordConfig.feminizeSign);
  };

  NumberSection.prototype.getWordFromThirteenToNineTeen = function (numGroup) {
    return this.arabicWordConfig.numbers[numGroup[1]] + ' ' + this.arabicWordConfig.numbers[10];
  };

  NumberSection.prototype.getWordFromTwentyToNinetyNine = function (tensGroup) {
    var tensChar = tensGroup[0];
    var singularChar = tensGroup[1];
    var tensNum = Number(tensChar);
    var singularNum = Number(singularChar);
    var tensWord = null;
    var singularWord = null;

    if (tensNum == 2) {
      tensWord = this.arabicWordConfig.numbers[20];
    } else if (tensNum >= 3 && tensNum <= 9) {
      tensWord = this.arabicWordConfig.numbers[tensChar] + this.arabicWordConfig.getAll().tensPrefix;
    }

    if (singularNum == 0) {
      return tensWord;
    } else if (tensNum >= 1 && tensNum <= 9) {
      singularWord = this.arabicWordConfig.numbers[singularChar];
    } else if (tensNum === 10) {
      singularWord = this.arabicWordConfig.numbers[tensNum];
    } else if (tensNum >= 11 && tensNum <= 12) {
      singularWord = this.arabicWordConfig.numbers[tensGroup];
    } else if (tensNum >= 13 && tensNum <= 19) {
      singularWord = this.getWordFromThirteenToNineTeen(tensGroup);
    }

    return singularWord + (singularWord ? ' ' + this.arabicWordConfig.getAll().numberSectionsDelimiter + ' ' : '') + tensWord;
  };

  return NumberSection;
}();

exports.NumberSection = NumberSection;

var ArabicWord =
/** @class */
function () {
  function ArabicWord(config) {
    this.config = new ArabicWordConfig();
    this.numberSection = new NumberSection(this.config);
    this.delimiter = 'و';

    if (config) {
      this.setConfig(config);
    }
  }
  /**
   * override the library config for example the delimiter and the result type
   * @param config {Config}
   * @returns
   */


  ArabicWord.prototype.setConfig = function (config) {
    this.config.overrideConfig(config);
    return this;
  };
  /**
   *
   * @param num {number} transform the number to arabic words
   * @returns
   */


  ArabicWord.prototype.process = function (num) {
    var sections = this.splitIntoSections(num);

    if (this.config.getAll().strict) {
      var result = {};

      if (!!sections[0]) {
        result.base = this.numberSection.process(sections[0]).join(" ".concat(this.delimiter, " "));
      }

      if (!!sections[1]) {
        result.delimiter = this.config.getAll().delimiter;
        result.reminder = this.numberSection.process(sections[1]).join(" ".concat(this.delimiter, " "));
      }

      return result;
    } else {
      var resultInStringSections = [];

      if (!!sections[0]) {
        var leftSide = this.numberSection.process(sections[0]);
        resultInStringSections.push(leftSide.join(" ".concat(this.delimiter, " ")));
      }

      if (!!sections[1]) {
        var rightSide = this.numberSection.process(sections[1]);
        resultInStringSections.push(rightSide.join(" ".concat(this.delimiter, " ")));
      }

      return resultInStringSections.join(" ".concat(this.config.getAll().delimiter, " "));
    }
  };

  ArabicWord.prototype.create = function () {
    return new ArabicWord();
  };

  ArabicWord.prototype.splitIntoSections = function (num) {
    return num.toString().split('.');
  };

  return ArabicWord;
}();

exports.ArabicWord = ArabicWord;
exports.arabicWord = new ArabicWord();

function toArabicWord(number) {
  return exports.arabicWord.process(number);
}

exports.toArabicWord = toArabicWord;
//# sourceMappingURL=index.js.map